exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-layout-root-5e6c4{display:flex}", ""]);

// Exports
exports.locals = {
	"root": "app-layout-root-5e6c4"
};